// Утилиты ссылки приглашения. Используются:
// - на странице Настройки → Пользователи и роли (вкладка «Приглашения»),
// - на карточке компании /company/:id (блок «Ссылка для регистрации»).
//
// Раньше эти же функции жили локально в UsersRolesSettings.tsx; вынесли
// сюда, чтобы при смене пути регистрации или формата URL править в
// одном месте, и чтобы на карточке компании ссылка строилась так же,
// как в настройках.

export interface InviteStatusStyle {
  label: string;
  bg: string;
  fg: string;
}

export const INVITE_STATUS_STYLE: Record<string, InviteStatusStyle> = {
  unused: { label: 'Ожидает', bg: '#FFF4E5', fg: '#B26B00' },
  used: { label: 'Использовано', bg: '#E8F6EE', fg: '#1F7A3A' },
  blocked: { label: 'Отозвано', bg: '#FDEAEA', fg: '#B42318' },
};

// На localhost важно сохранять порт, иначе ссылка ведёт на
// http://localhost/ без `:3000` — dev-сервер на это ругается.
// На проде порт обычно стандартный (80/443), его не дописываем.
export function getBaseUrl(): string {
  const { protocol, hostname, port } = window.location;
  const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';
  return isLocalhost
    ? `${protocol}//${hostname}:${port}`
    : `${protocol}//${hostname}`;
}

export function buildInviteLink(inviteId: string): string {
  return `${getBaseUrl()}/registration/${inviteId}`;
}

export async function copyToClipboard(text: string): Promise<boolean> {
  // Современный API доступен только в secure-контексте (https / localhost).
  // На staging иногда без него — поэтому есть legacy-фолбэк через
  // скрытый textarea + execCommand('copy').
  try {
    if (navigator?.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    /* падаем в legacy */
  }
  try {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    document.execCommand('copy');
    document.body.removeChild(ta);
    return true;
  } catch {
    return false;
  }
}
